var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNoResultsBinoculars = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 117 118",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M27.004 85.682c-9.488 0-17.198-7.71-17.198-17.198s7.71-17.199 17.198-17.199 17.199 7.71 17.199 17.199c0 9.488-7.71 17.198-17.199 17.198Z",
  stroke: "#F15B35",
  strokeWidth: 2,
  strokeMiterlimit: 10
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M52.24 30.641c-2.431-3.239-6.27-5.18-10.327-5.18-2.781 0-5.42.872-7.656 2.52-.97.719-1.832 1.57-2.541 2.486L11.104 50.675l-.076.11c-4.832 4.373-7.896 10.676-7.896 17.7 0 13.163 10.71 23.883 23.884 23.883s22.956-9.837 23.796-22.248l2.389-17.83",
  stroke: "#5C6471",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M3.12 68.485c0-13.174 10.72-23.883 23.884-23.883 13.163 0 23.884 10.72 23.884 23.883",
  stroke: "#5C6471",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M71.237 68.484c0-9.488 7.71-17.199 17.199-17.199 9.488 0 17.198 7.71 17.198 17.199 0 9.488-7.71 17.198-17.198 17.198s-17.21-7.71-17.199-17.198Z",
  stroke: "#F15B35",
  strokeWidth: 2,
  strokeMiterlimit: 10
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M62.132 52.213s2.497 17.886 2.508 17.907c.85 12.411 11.19 22.248 23.797 22.248 13.163 0 23.883-10.71 23.883-23.884 0-7.023-3.064-13.326-7.895-17.7-.022-.032-.033-.076-.077-.109L83.736 30.467a12.495 12.495 0 0 0-2.54-2.487 12.807 12.807 0 0 0-7.657-2.52c-4.057 0-7.895 1.942-10.328 5.181",
  stroke: "#5C6471",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M64.553 68.485c0-13.174 10.72-23.883 23.883-23.883 13.175 0 23.884 10.71 23.884 23.883",
  stroke: "#5C6471",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "m32.162 41.414 6.02-7.732c.186-.24.415-.436.655-.59 0 0 .392-.239.883-.337 8.234-1.57 18.322-1.56 18.322-1.56s9.542 0 17.667 1.56c.491.098.884.338.884.338a2.4 2.4 0 0 1 .654.589l6.02 7.732A286.721 286.721 0 0 0 57.78 40.28c-9.194 0-17.776.436-25.629 1.134h.011Z",
  stroke: "#A4ABB7",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  d: "M52.981 52.255a23.47 23.47 0 0 0-6.161-6.5c-5.879-4.188-12.051-4.427-14.472-4.384M52.948 52.258h9.5M83.049 41.362c-2.421-.033-8.594.196-14.472 4.384-3.065 2.181-5.006 4.7-6.162 6.5",
  stroke: "#A4ABB7",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export default SvgNoResultsBinoculars;